module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }